module.exports = __webpack_public_path__ + "img/user-avatar-4.5352a296.png";